<template>
  <v-select
    :label="$t('queueDataLogs.Fields.type')"
    v-model="model"
    :items="queueDataTypes"
    item-text="value"
    item-value="key"
    chips
    multiple
    clearable
    deletable-chips
    small-chips
  ></v-select>
</template>

<script>
import Logs from "@/api/logs";


export default {
  name: "SearcherQueueDataTypes",

  props: ["value"],


  computed: {
    queueDataTypes() {
      let arr = []
      for(let index in this.types){
          let i = {};
          i.key = index;
          i.value = this.types[index]
          arr.push(i)
      }
      return arr
    },
  },
  mounted(){
      this.getQueueDataTypes()
  },
  methods:{
    getQueueDataTypes(){
          Logs.getQueueDataTypes().then(
              function (response){
                  if(response.data.status.isOK()){
                      this.types = response.data.types
                  }
              }.bind(this)
          )
      }
  },

  data: () => ({
    model: [],
    types:[]

  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.model = this.value;
      },
    },
    model: {
      handler() {
        this.$emit("input", this.model);
      },
    },
  },
};
</script>
